// Whether a newer control plane is out, for the menu's dot beside 系统更新:
// read once at sign-in and then every half hour — the control plane itself
// asks the release site hourly, this only reads its last answer.
import { ref } from 'vue'
import { api } from '@/api/client'

export const updateAvailable = ref(false)
let timer: ReturnType<typeof setInterval> | undefined

export async function refreshUpdate() {
  try {
    updateAvailable.value = (await api.systemUpdate()).available
  } catch {
    // The dot is a hint; without it the page still says.
  }
}

export function watchUpdate() {
  if (timer) return
  void refreshUpdate()
  timer = setInterval(() => void refreshUpdate(), 30 * 60_000)
}
